<!-- 新闻动态 -->
<template>
	<div class="news" style="padding: 2rem 0;">
		<div class="container">
			<div class="page-title">
				<div id="newsTitle">{{ currNew.title }}</div>
				<p class="news-time text_align_center">
					文章来源：<span id="newsSource">{{ currNew.source }}</span>
					发布时间：<span id="newsTime">{{ currNew.time }}</span>
				</p>
			</div>
			<div class="news-detail">
				<div v-for="(item,i) in currNew.content" :key="'content'+i">
					<!-- 文本 -->
					<p v-if="item.type== 'txt'" class="news-synopsis">{{ item.section }}</p>
					<!-- 图片 -->
					<div v-else-if="item.type== 'image'" class="text_align_center margin_10">
						<img :src="item.section" :alt="item.name">
					</div>
					<!-- 标题 -->
					<div v-else-if="item.type== 'title'" class="news-title border_left_title margin_vertical_10">{{ item.section }}</div>
					<!-- 视频 -->
					<video v-else-if="item.type== 'video'" :src="item.section" controls="controls"></video>
					<p v-else-if="item.type== 'video'" class="news-text_align_center">{{ item.name }}</p>
					<!-- 音频 -->
					<audio v-else-if="item.type== 'video'" :src="item.section" controls="controls"></audio>
					<p v-else-if="item.type== 'video'" class="news-text_align_center">{{ item.name }}</p>
				</div>
				<!-- 落款 -->
				<p v-if="currNew.object && currNew.object.length > 0" v-for="(objItem, key) in currNew.object" :key="key" class="news-synopsis text_align_right">{{ objItem }}</p>
			</div>
		</div>
	</div>
</template>

<script>
	// import arrNews from '../assets/news/news2020.json';
	export default {
		name: "NewsDetail",
		data() {
			return {
				currNew: {} //当前新闻
			}
		},
		mounted: function() {
			//获取新闻
			const newsid = this.$fun.GetUrlParam("newsid");
			this.$axios.get('/new/detail?newsid=' + newsid)
				.then(res => {
					if (res.status == 200 && res.data) {
						this.currNew = res.data;
					} else {
						this.$message('新闻获取失败！');
					}
				});
			// const arrNews = require('../assets/news/news2018.json');
			// const newsid = this.$fun.GetUrlParam("newsid");
			// arrNews.map((item, index) => {
			// 	if (item.newsid == newsid) {
			// 		this.currNew = item; //当前要显示的新闻
			// 	}
			// });
		}
	}
</script>

<style>
	.news-detail img {
		max-width: 100%;
	}
</style>
